import * as React from 'react';
import { CornerDownRight, Percent } from 'lucide-react';
import { Fqdn } from '@gandi/ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "DetailRow-root_36lQF"
};
export function DetailRow({
  isFqdn,
  isPromo,
  label
}) {
  return /*#__PURE__*/_jsxs("li", {
    className: styles.root,
    children: [isPromo ? /*#__PURE__*/_jsx(Percent, {
      size: 16
    }) : /*#__PURE__*/_jsx(CornerDownRight, {
      size: 16
    }), isFqdn ? /*#__PURE__*/_jsx(Fqdn, {
      children: label
    }) : /*#__PURE__*/_jsx("span", {
      children: label
    })]
  });
}